<template>
    <div :class="['navbar-area', { 'is-sticky': isSticky }]">
        <div class="meander_software-nav">
            <div class="container">
                <nav class="navbar navbar-expand-lg navbar-light bg-light flex-nowrap">
                    <router-link class="navbar-brand" to="/" v-if="!active">
                        <img src="../../assets/images/newlogo.png" alt="logo">
                        <img src="../../assets/images/black-logo.png" alt="logo">
                    </router-link>


                    <div class="collapse navbar-collapse gap-4 justify-content-start  " :class="{ show: active }">
<div class="d-flex align-items-center justify-content-between d-lg-none" style="    padding-bottom: 25px;
    border-bottom: 1px solid gray;">
                        <router-link class="navbar-brand" to="/"  >
                            <img src="../../assets/images/newlogo.png" alt="logo">
                            <img src="../../assets/images/black-logo.png" alt="logo">
                        </router-link>
 

<div :class="`navbar-toggler `" @click="active = !active" :aria-pressed="active ? 'true' : 'false'"
                        v-bind:class="{ 'active': button_active_state }"
                        v-on:click="button_active_state = !button_active_state">
                        <span class="icon-bar top-bar"></span>
                        <span class="icon-bar middle-bar"></span>
                        <span class="icon-bar bottom-bar"></span>
                    </div>

</div>

                        <!-- Desktop Menu -->
                        <ul class="navbar-nav m-0 header-new d-none d-lg-flex">

                            <li class="nav-item megamenu">
                                <a href="#" class=" nav-link">Models</a>
                                <ul class="dropdown-menu" v-if="appCategories?.length">
                                    <li class="nav-item">
                                        <div class="container">
                                            <div class="row">
                                                <div class="col"
                                                    v-for="(category, categoryIndex) in sortedAppCategories"
                                                    :key="category.slug">
                                                    <h6 class="submenu-title">{{ category.name }}</h6>
                                                    <ul class="megamenu-submenu">
                                                        <li v-for="app in categoryIndex == 4 ? category.business_models.slice(0, 4) : category.business_models"
                                                            :key="app.slug">
                                                            <router-link :to="`/app-detail/${app.slug}`"
                                                                @click="setAppsInLocalStorage(category)">{{ app?.name
                                                                }}</router-link>
                                                        </li>
                                                    </ul>
                                                    <div v-if="categoryIndex == 4" class="others-option">
                                                    <!-- <router-link to="/contact" class="default-btn">Contact</router-link> -->
                                                        <button class="default-btn py-1 mt-2"
                                                            @click="$router.push('/projects')">See All</button>
                                                    </div>
                                                </div>

                                              
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item">
                                <a href="#" class=" nav-link">Products</a>
                                <ul class="dropdown-menu">
                                    <li class="nav-item" v-for="product in products" :key="product.slug">
                                        <router-link :to="`/products/${product?.slug}`" TeamTwo class="nav-link">{{
                                            product?.name }}</router-link>
                                    </li>



                                </ul>
                            </li>
                        <li class="nav-item">
                                <router-link to="/products/meander-one" class="nav-link">Integration</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/products/doers-online" class="nav-link">Plug n Play</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/resources" class="nav-link">Resources</router-link>
                            </li>
                          

                        </ul>

                        <!-- Mobile Menu with Accordion -->
                        <ul class="navbar-nav m-0 header-new d-lg-none" style="    overflow-y: auto;
    max-height: 400px;">
                            <li class="nav-item">
                                <a href="#" class="nav-link d-flex align-items-center justify-content-between" @click="toggleAccordion('models')">
                                    Models
                                    <i class="d-inline  ri-arrow-down-s-line ms-1" :class="expandedMenuItems.models ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                                </a>
                                <ul class="dropdown-menu" v-if="appCategories?.length && expandedMenuItems.models">
                                    <li class="nav-item">
                                        <div >
                                            <div class="row" style="flex-direction: column;">
                                                <div class="col"
                                                    v-for="(category, categoryIndex) in sortedAppCategories"
                                                    :key="category.slug">
                                                    <h6 class="submenu-title" style="    padding: 12px 0px;
    border-bottom: 1px #9898984f solid;">{{ category.name }}</h6>
                                                    <ul class="megamenu-submenu">
                                                        <li v-for="app in categoryIndex == 4 ? category.business_models.slice(0, 4) : category.business_models"
                                                            :key="app.slug">
                                                            <router-link :to="`/app-detail/${app.slug}`"
                                                                @click="closeMobileMenu(); setAppsInLocalStorage(category)">{{ app?.name
                                                                }}</router-link>
                                                        </li>
                                                    </ul>
                                                    <div v-if="categoryIndex == 4" class="others-option">
                                                        <button class="default-btn py-1 mt-2"
                                                            @click="closeMobileMenu(); $router.push('/projects')">See All</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item">
                                <a href="#" class="nav-link d-flex align-items-center justify-content-between" @click="toggleAccordion('products')">
                                    Products
                                    <i class="d-inline ri-arrow-down-s-line ms-1" :class="expandedMenuItems.products ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                                </a>
                                <ul class="dropdown-menu" v-if="expandedMenuItems.products">
                                    <li class="nav-item" v-for="product in products" :key="product.slug">
                                        <router-link :to="`/products/${product?.slug}`" class="nav-link" @click="closeMobileMenu()">{{
                                            product?.name }}</router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item">
                                <router-link to="/products/meander-one" class="nav-link" @click="closeMobileMenu()">Integration</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/products/doers-online" class="nav-link" @click="closeMobileMenu()">Plug n Play</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/resources" class="nav-link" @click="closeMobileMenu()">Resources</router-link>
                            </li>
                        </ul>
                        <transition name="fade-slide ">
                            <aside v-if="showAside" class="d-none d-lg-block widget-area left-sidebar w-40">
                                <div class="widget widget_search">
                                    <form class="search-form">
                                        <label class="search-container">
                                            <input type="search" class="search-field" placeholder="Search..."
                                                v-model="searchQuery" @input="handleSearch"
                                                @focus="showSearchResults = true" @blur="handleBlur">
                                            <button type="button">
                                                <svg fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 16 16" width="16px" height="16px">
                                                    <path
                                                        d="M13.438,15.563l-2.665-2.664	C9.684,13.598,8.388,14.002,7,14.002c-3.865,0-7-3.135-7-7c0-3.864,3.135-7,7-7c3.864,0,7,3.136,7,7	c0,1.391-0.407,2.687-1.105,3.776l2.665,2.664c0.585,0.585,0.585,1.536,0,2.121C14.974,16.148,14.024,16.148,13.438,15.563z M12,7.002c0-2.759-2.241-5-5-5c-2.76,0-5,2.241-5,5c0,2.76,2.24,5,5,5C9.759,12.002,12,9.762,12,7.002z" />
                                                </svg>
                                            </button>
                                            <!-- Search Results Dropdown -->
                                            <div v-if="showSearchResults && filteredApps.length > 0"
                                                class="search-results-dropdown">
                                                <div v-for="app in filteredApps" :key="app.slug"
                                                    class="search-result-item" @click="navigateToApp(app.slug)">
                                                    {{ app.name }}
                                                </div>
                                            </div>
                                        </label>
                                    </form>
                                </div>
                            </aside>
                        </transition>
                    </div>
                    <transition name="fade-slide" v-if="!active" class="d-lg-none">
                        <aside v-if="showAside" class="widget-area left-sidebar w-40 m-0">
                            <div :class="` ${isContect ? 'bg-tran' : ''} widget widget_search`">
                                 <form :class="`search-form d-none   d-lg-block`"
                                    @submit.prevent>
                                    <label class="search-container">
                                        <input type="search" class="search-field" placeholder="Search..."
                                            v-model="searchQuery" @input="handleSearch"
                                            @focus="showSearchResults = true" @blur="handleBlur">
                                         
                                        <div v-if="showSearchResults && filteredApps.length > 0"
                                            class="search-results-dropdown">
                                            <div v-for="app in filteredApps" :key="app.slug" class="search-result-item"
                                                @click="navigateToApp(app.slug)">
                                                {{ app.name }}
                                            </div>
                                        </div>
                                    </label>
                                </form>  
                                <form :class="`search-form ${isContect ? 'd-block' : 'd-none'} d-md-none`"
                                    @submit.prevent>

                                    <!-- <i @click="handleSearchIconClick() " class="ri-search-2-line Sreach-icon"></i> -->
                                    <img @click="handleSearchIconClick()" src="../../assets/images/icons-search-nav.svg" alt="search icon" width="25px" height="25px" class="Sreach-icon">
                                </form>
                            </div>
                        </aside>
                    </transition>
                    <div :class="`others-opti  d-block `"
                                    v-if="!active">
                                    <button class="default-btn ms-2 contact-btn" @click="openPopup()">Contact</button>

                      
                    </div>



                    <div :class="`navbar-toggler ${  !active ? 'd-block  ' : 'd-none'} d-lg-none`" @click="active = !active" :aria-pressed="active ? 'true' : 'false'"
                        v-bind:class="{ 'active': button_active_state }"
                        v-on:click="button_active_state = !button_active_state">
                        <span class="icon-bar top-bar"></span>
                        <span class="icon-bar middle-bar"></span>
                        <span class="icon-bar bottom-bar"></span>
                    </div>


                </nav>
            </div>
        </div>
     
 
    <div style="    padding: 10px 10px 0px;
    position: absolute;
    width: 100%;
    top: 66px;" v-if="showAside"  class="d-block d-md-none">
        <transition name="fade-slide" v-if="!active" class="d-lg-none">
                        <aside  class="widget-area left-sidebar w-100 m-0">
                            <div :class="` ${isContect ? 'bg-tran' : ''} widget widget_search`">
                                <form :class="`search-form ${isContect ? 'd-none' : 'd-block'}  `"
                                style="border: 1px solid #989898c7; border-radius: 10px;"
                                    @submit.prevent>
                                    <label class="search-container">
                                        <input type="search" class="search-field"  placeholder="Search..."
                                            v-model="searchQuery" @input="handleSearch"
                                            @focus="showSearchResults = true" @blur="handleBlur" >
                                        <!-- <button type="button"><i class="ri-search-2-line"></i></button> -->
                                        <!-- Search Results Dropdown -->
                                        <div v-if="showSearchResults && filteredApps.length > 0"
                                            class="search-results-dropdown">
                                            <div v-for="app in filteredApps" :key="app.slug" class="search-result-item"
                                                @click="navigateToApp(app.slug)">
                                                {{ app.name }}
                                            </div>
                                        </div>
                                    </label>
                                </form>
               
                            </div>
                        </aside>
                    </transition>
     </div>   </div>
</template>

<script>
import { watchEffect } from "vue";
import { Search_APP, useGetNavMenuData } from '../../services/graphqlService';
import apolloClient from "../../apollo";
export default {
    name: 'Navbar',
    props: {
        openPopup: Function
    },
    data() {
        return {
            hideSearchTimeout: null,
            isSticky: true, //it was false and now temporary true 
            isMenu: false,
            isContect: true,
            active: false,
            button_active_state: false,
            appCategories: [],
            technologiesCategories: [],
            services: [],
            industries: [],
            products: [],
            baseUrl: 'https://content.meander.software',
            showAside: false, // Added to control aside visibility
            searchQuery: '',
            showSearchResults: false,
            allowedCategoriesOrder: [
      'Trending Apps',
      'Popular Apps',
      'On Demand Apps',
      'Business Apps',
      'Social Apps',
    ],
            filteredApps: [],
            allApps: [], // Will store all apps from categories
            // Mobile accordion states
            expandedMenuItems: {
                models: false,
                products: false
            },
            // Store scroll event listeners for proper cleanup
            scrollListeners: {
                home: null,
                projects: null
            }
        }
    },
    computed: {
         sortedAppCategories() {
    return this.allowedCategoriesOrder
      .map(name => this.appCategories.find(cat => cat.name === name))
      .filter(Boolean); // removes undefined if category not found
  },
        isHomePage() {
            return this.$route.path === '/';
        },
        isProjectsPage() {
            return this.$route.path === '/projects';
        }
    },
    watch: {
        '$route.path'(newPath) {
            // Remove existing listeners first
            this.removeScrollListeners();
            
            if (newPath === '/') {
                // On home, use scroll logic with default 550px
                this.handleScroll(550);
                this.scrollListeners.home = () => this.handleScroll(550);
                window.addEventListener('scroll', this.scrollListeners.home);
            } else if (newPath === '/projects') {
                // On projects page, use 400px threshold
                this.handleScroll(400);
                this.scrollListeners.projects = () => this.handleScroll(400);
                window.addEventListener('scroll', this.scrollListeners.projects);
            } else {
                // On other pages, always show aside
                this.showAside = true;
            }
        }
    },
    async mounted() {
        await this.getNavMenuData();
        if (this.isHomePage) {
            this.scrollListeners.home = () => this.handleScroll(550);
            window.addEventListener('scroll', this.scrollListeners.home);
            this.handleScroll(550); // Set initial state with default 550px
        } else if (this.isProjectsPage) {
            this.scrollListeners.projects = () => this.handleScroll(400);
            window.addEventListener('scroll', this.scrollListeners.projects);
            this.handleScroll(400); // Set initial state with 400px
        } else {
            this.showAside = true;
        }
    },
    beforeUnmount() {
        this.removeScrollListeners();
    },
    methods: {
        removeScrollListeners() {
            if (this.scrollListeners.home) {
                window.removeEventListener('scroll', this.scrollListeners.home);
                this.scrollListeners.home = null;
            }
            if (this.scrollListeners.projects) {
                window.removeEventListener('scroll', this.scrollListeners.projects);
                this.scrollListeners.projects = null;
            }
        },
        handleSearchIconClick() {
    this.isContect = false;

    // Start 3-second timer
    this.hideSearchTimeout = setTimeout(() => {
      if (!this.searchQuery.trim()) {
        this.isContect = true;
      }
    }, 3000);
  },
        handleScroll(height = 550) {
            let scrollPos = window.scrollY
            if (scrollPos >= 100) {
                this.isSticky = true
            } else {
                this.isContect = true
                this.isSticky = true //it was false and now temporary true 
            }
            this.showAside = scrollPos >= height; // Show aside after specified height
        },

        async getNavMenuData() {
            const { result, onError } = useGetNavMenuData();
            watchEffect(() => {
                if (result?.value?.businessModelCategories?.length) {
                    this.appCategories = result?.value?.businessModelCategories;
                    // console.log('this.appCategories',this.appCategories);
                    this.extractAllApps(); // Extract all apps for search
                }
                if (result?.value?.products?.length) {
                    this.products = result?.value?.products;
                }
                if (result?.value?.services?.length) {
                    this.services = result?.value?.services;
                }
                if (result?.value?.industries?.length) {
                    this.industries = result?.value?.industries;
                }
                if (result?.value?.technologiesCategories?.length) {
                    this.technologiesCategories = result?.value?.technologiesCategories;
                }
            });

            onError((error) => {
                console.error("Error fetching app by slug:", error);
            });
        },

        //local storage-------->
        setAppsInLocalStorage(newApps) {
            try {
                // const filteredApps = newApps?.attributes?.related_apps?.data.filter(app => app?.attributes?.isadd);
                // Remove existing data
                localStorage.removeItem('relatedApps');

                // Save new data
                localStorage.setItem('relatedApps', JSON.stringify(newApps));
            } catch (error) {
                console.error(error);
                console.error('Error setting data in local storage:', error);
            }
        },
        // setproductsInLocalStorage(newproducts) {
        //     try {
        //         // Remove existing data
        //         localStorage.removeItem('relatedproducts');

        //         // Save new data
        //         localStorage.setItem('relatedproducts', JSON.stringify(newproducts));
        //     } catch (error) {
        //         console.error(error);
        //         console.error('Error setting data in local storage:', error);
        //     }
        // },
        settechologiesInLocalStorage(newtechologies) {
            try {
                // Remove existing data
                localStorage.removeItem('relatedTechologies');

                // Save new data
                localStorage.setItem('relatedTechologies', JSON.stringify(newtechologies));
            } catch (error) {
                console.error(error);
            }
        },
        setIndustriesInLocalStorage(newIndustries) {
            try {
                // Remove existing data
                localStorage.removeItem('newIndustries');

                // Save new data
                localStorage.setItem('newIndustries', JSON.stringify(newIndustries));
            } catch (error) {
                console.error(error);
            }
        },
        setServiceInLocalStorage(newservice) {
            try {
                // Remove existing data
                localStorage.removeItem('newservice');

                // Save new data
                localStorage.setItem('newservice', JSON.stringify(newservice));
            } catch (error) {
                console.error(error);
            }
        },

        // Search functionality methods
        async handleSearch() {
            clearTimeout(this.hideSearchTimeout); 
            if (this.searchQuery.trim() === '') {
                this.filteredApps = [];
                return;
            }
            const query = this.searchQuery.toLowerCase();
            const variables = {
                "filters": {
                    "or": [
                        {
                            "clone_synonyms": {
                                "containsi": query
                            }
                        },
                        {
                            "alias_synonyms": {
                                "containsi": query
                            }
                        },
                        {
                            "keywords": {
                                "containsi": query
                            }
                        },
                        {
                            "name": {
                                "containsi": query
                            }
                        },
                        {
                            "description": {
                                "containsi": query
                            }
                        },
                    ]

                },
                pagination: { page: 1, pageSize: 100 }
            }
            const { data } = await apolloClient.query({
                query: Search_APP,
                variables
            })
            watchEffect(() => {
               
                this.filteredApps = data?.apps

            });


        },


        handleBlur() {
            // Delay hiding results to allow click events to fire
            setTimeout(() => {
                this.showSearchResults = false;
            }, 200);
            setTimeout(() => {
                this.isContect = true;
            }, 200);
        },

        navigateToApp(slug) {
            this.showSearchResults = false;
            this.searchQuery = '';
            this.$router.push(`/app-detail/${slug}`);
        },

        // Mobile accordion methods
        toggleAccordion(menuKey) {
            this.expandedMenuItems[menuKey] = !this.expandedMenuItems[menuKey];
        },

        closeMobileMenu() {
            this.active = false;
            this.button_active_state = false;
            // Reset all accordion states
            Object.keys(this.expandedMenuItems).forEach(key => {
                this.expandedMenuItems[key] = false;
            });
        },

        // Extract all apps from categories
        extractAllApps() {
            this.allApps = [];
            if (this.appCategories && this.appCategories.length > 0) {
                this.appCategories.forEach(category => {
                    if (category.business_models && category.business_models.length > 0) {
                        category.business_models.forEach(app => {
                            this.allApps.push({
                                name: app.name,
                                slug: app.slug
                            });
                        });
                    }
                });
            }
        },


    }
}
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: opacity 0.4s, max-height 0.4s, margin 0.4s, padding 0.4s;
    overflow: hidden;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    max-height: 0;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
}

.fade-slide-enter-to,
.fade-slide-leave-from {
    opacity: 1;
    max-height: 200px;
    /* adjust as needed for your aside's height */
    margin-top: 0.5rem;
    /* or your normal margin */
    margin-bottom: 0.5rem;
    padding-top: 1rem;
    /* or your normal padding */
    padding-bottom: 1rem;
}

/* Responsive logo styling */
@media (max-width: 500px) {
    .navbar-brand img {
        width: 150px;
        height: auto;
    }
}

/* Contact button positioning for small screens */
@media only screen and (max-width: 500px) {
    .navbar-area .meander_software-nav .navbar .others-option {
        top: 0px !important;
        left: 150px !important;
    }
}

/* Search functionality styles */
.search-container {
    position: relative;
    display: block;
    width: 100%;
}

.Sreach-icon {
    font-size: 25px;
    color: #ffffff;
}

.bg-tran {
    background-color: transparent !important;
}

.search-results-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-height: 400px;
    overflow-y: auto;
    z-index: 1000;
    margin-top: 2px;
}

.search-result-item {
    padding: 10px 15px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s ease;
}

.search-result-item:hover {
    background-color: #f8f9fa;
}

.search-result-item:last-child {
    border-bottom: none;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
    .search-results-dropdown {
        max-height: 300px;
    }
}


</style>